const ROOT = 'TALENT_PENDING_SKILLS_';

const actions = {
  CHANGE_MODAL_VISIBILITY: `${ROOT}CHANGE_MODAL_VISIBILITY`,
  CLEAR_STATE: `${ROOT}CLEAR_STATE`,
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  PROCESS_ACTION_SUCCESS: `${ROOT}PROCESS_ACTION_SUCCESS`,
  PROCESS_ACTION_ERROR: `${ROOT}PROCESS_ACTION_ERROR`,
  LOAD_REVIEW_PENDING_DATA_SUCCESS: `${ROOT}LOAD_REVIEW_PENDING_DATA_SUCCESS`,
  LOAD_DATA_SUCCESS: `${ROOT}LOAD_DATA_SUCCESS`,
} as const;

export default actions;
